import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import { Grid, Popup, Input, Dropdown, Segment} from 'semantic-ui-react';
import debounce from "lodash.debounce"

const regex = new RegExp('[A-Za-z0-9 _.,!$]*');

export class BasicFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: this.props.filter || "",
      filterValid: true,
      loadedSave: false,
      advancedFilters : this.props.advancedFilters,
      advancedFilterSelections: {
          

      }, // Initialize an empty object for selections
    };

    this.debouncedSubmit = debounce(this.props.onSubmitFilter, this.props.interval || 500);
  }

  componentDidMount()
  {
  }

  componentDidUpdate(prevProps)
  {
    
    if (this.props.meterTypeOverride !== prevProps.meterTypeOverride) {

          
      this.setState({
          advancedFilterSelections: {
              ...this.state.advancedFilterSelections,
              'MeterType': [this.props.meterTypeOverride.toLowerCase()]
          }
      });
  }

  if (this.props.queryTypeOverride !== prevProps.queryTypeOverride) {

          
    this.setState({
        advancedFilterSelections: {
            ...this.state.advancedFilterSelections,
            'QueryType': [this.props.queryTypeOverride.toLowerCase()]
        }
    });
}

  if (this.props.supplyOverride !== prevProps.supplyOverride) {

          
    this.setState({
        advancedFilterSelections: {
            ...this.state.advancedFilterSelections,
            'Utility': [this.props.supplyOverride.toLowerCase()]
        }
    });
}

    if(this.state.filter === "" && this.props.filter !== "" && this.state.loadedSave === false)
    {
     
      this.setState({
        filter : this.props.filter,
        filterValid : true,
        loadedSave : true,
        advancedFilters : this.props.advancedFilters
      })

      this.debouncedSubmit({ filter: this.props.filter });
    } else

    {
      if(!this.state.advancedFilters && this.props.advancedFilters)
      {
      this.setState({
        advancedFilters : this.props.advancedFilters
      })
    }
    }
  }

  handleChangeDropDown = (_p, {name, value }) => {

    this.setState(prevState => ({
      advancedFilterSelections: {
          ...prevState.advancedFilterSelections,
          [name]: value, // Update the selection for this filter
      }
  }));

    this.props.onAdvancedFilterChange({name, value })

  };

  handleOnChange = (event, { name, value }) => {
    
    if (value !== '' && !regex.test(value)) {
      this.setState({ [name]: value, filterValid: false });
    } else {
      this.setState({ [name]: value, filterValid: true }, this.raiseChange);
    }
  };

  raiseChange = () => {
    this.debouncedSubmit({ filter: this.state.filter });

  }


  render() {
    const { filter } = this.state;
    let popupMessage = '';
    if (!this.state.filterValid) {
      popupMessage = 'Invalid character.';
    } else if (this.props.totalCount === 0) {
      //popupMessage = 'No results found.';
    }

    return (
      
        <Grid padded stackable columns='equal'>
            <Grid.Row>
              <Grid.Column>
                <Popup
                    trigger={
                      <Fragment>
                        <h4>Filter</h4>
                      <Input
                          fluid
                          placeholder="Enter the filter."
                          name="filter"
                          value={filter}
                          defaultValue={filter}
                          error={!this.state.filterValid}
                          onChange={this.handleOnChange}
                          icon="search"
                          disabled={this.props.disabled}
                      />

                    
                      
{(this.state && this.state.advancedFilters && this.state.advancedFilters.length) > 0 &&
              

              
              <Grid.Row>
                <Grid.Column>
              <Segment.Group horizontal>
           
                    {this.state.advancedFilters.map((el, index) =>  {

                    let options = [...el.filterValues];
                    


                    return (
                      <Segment key={index}>
                        <h4>
                        {el.filterName === 'HHDataType'
                            ? 'AMR/HH'
                            : el.filterName.replace(/([A-Z])/g, ' $1').trim()
                        }
                        </h4>
                      <Dropdown
                      
                      key={this.state.advancedFilterSelections[el.filterName] ? 'selected' : 'not-selected'} // Force re-render

                      name={el.filterName} 
                      placeholder={el.filterName} 
                      multiple fluid selection 
                      options={options}
                      value={this.state.advancedFilterSelections[el.filterName] || []} // Use state-controlled value

                      onChange={this.handleChangeDropDown} />
                      
                      </Segment>
                    );
                     } )}
                </Segment.Group>
                </Grid.Column>
            </Grid.Row>

            }

                      </Fragment>
                    }
                    content={popupMessage}
                    on="click"
                    open={!this.state.filterValid}
                    position="right center"
                />
              </Grid.Column>
            </Grid.Row>
        </Grid>
    );
  }
}

BasicFilter.propTypes = {
  onSubmitFilter: PropTypes.func.isRequired,
  onAdvancedFilterChange : PropTypes.func,
  interval: PropTypes.number,
  disabled: PropTypes.bool,
  filter: PropTypes.string,
  totalCount: PropTypes.number.isRequired,
  meterTypeOverride : PropTypes.string,
  supplyOverride : PropTypes.string,
  queryTypeOverride : PropTypes.string
};
